import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import OrderGrid from "../../compenents/Order/OrderGrid";

interface OrdersProps {}

const Orders: React.FunctionComponent<OrdersProps> = (props) => {
  return (
    <>
      <Container maxWidth={false}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Orders
        </Typography>
        <OrderGrid></OrderGrid>
      </Container>
    </>
  );
};

export default Orders;
